export default "__VITE_ASSET__KR7lhnsB__"